<template>
  <div>敬请期待xxxxxxxxxx {{ name }}{{ data.name }}</div>
</template>
<script>
export default {
  name: 'SkyStepViewDefault',
  props: {
    data: Object,
    name: String
  },
  mounted() {},
  methods: {
    getData() {
      return {}
    },
    gotoNextStep() {
      this.message = '点击了下一步'
      return true
    },
    async gotoNextPreVliate() {
      return true
    },
    gotoPreStep() {
      this.message = '点击了上一步'
    }
  }
}
</script>
<style scoped>
.content {
  width: 100%;
  height: 300px;
  overflow: hidden;
}
</style>
